import {
	Button,
	createMuiTheme,
	MuiThemeProvider,
	TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deletePartidaCategory,
	getPartidaCategoryById,
	postPartidaCategory,
	updatePartidaCategory,
	getPartidaCategories,
} from "../../../../api/partidaCategory";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { useSkeleton } from "../../../hooks/useSkeleton";

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: "#F64E60",
		},
	},
});

function getEmptyCategory() {
	return {
		descripcion: null,
		referencia: null,
		categoria_padre_id: null,
	};
}

export default function EditPartidasCategoriesPage() {
	const [category, setCategory] = useState(getEmptyCategory());
	const [categories, setCategories] = useState([]);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

	const categoryId = useParams().id;
	const history = useHistory();
	const location = useLocation();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	const handleBack = () => {
		const prevTablePage = location.state?.page;

		history.push(
			`/categorias-partidas${
				prevTablePage ? "?page=" + prevTablePage : ""
			}`
		);
	};

	const {
		isLoading: isLoadingData,
		disableLoading: disableLoadingData,
		ContentSkeleton,
	} = useSkeleton();

	useEffect(() => {
		getPartidaCategories(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) setCategories(res.data);
			})
			.catch((error) => {
				alertError({ error, customMessage: "No se han podido obtener las categorías." });
			});

		if (!categoryId) {
			disableLoadingData();
			return;
		}
		getPartidaCategoryById(categoryId, loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setCategory(res.data);
					disableLoadingData();
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se ha podido obtener la categoría.",
				});
				handleBack();
			});
	}, [categoryId, disableLoadingData, history, loggedUser?.accessToken]);

	function saveCategory() {
		if (!categoryId) {
			postPartidaCategory(category, loggedUser?.accessToken)
				.then((res) => {
					if (res.status === 201) {
						alertSuccess({
							title: "¡Guardada!",
							customMessage: "Categoría guardada con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "No se ha podido guardar la categoría.",
					});
				});
		} else {
			updatePartidaCategory(categoryId, category, loggedUser?.accessToken)
				.then((res) => {
					if (res.status === 204) {
						alertSuccess({
							title: "¡Guardado!",
							customMessage: "Cambios guardados con éxito.",
						});
						handleBack();
					}
				})
				.catch((error) => {
					alertError({
						error: error,
						customMessage: "No se han podido guardar los cambios.",
					});
				});
		}
	}

	const handleChange = (element) => (event) => {
		setCategory({ ...category, [element]: event.target.value });
	};

	if (isLoadingData) return <ContentSkeleton />;
	else
		return (
			<>
				<Card>
					<CardHeader title="Capítulo">
						<CardHeaderToolbar>
							<Button
								onClick={() => saveCategory()}
								variant="outlined"
								color="primary"
								style={{
									marginRight: categoryId ? "20px" : "",
								}}
							>
								Guardar categoría
							</Button>
							{categoryId && (
								<>
									<MuiThemeProvider theme={theme}>
										<Button
											className="py-2"
											onClick={() =>
												setOpenConfirmDialog(true)
											}
											variant="outlined"
											color="secondary"
										>
											Eliminar categoría
										</Button>
									</MuiThemeProvider>
								</>
							)}
						</CardHeaderToolbar>
					</CardHeader>
					<CardBody>
						<TextField
							id={`descripcion`}
							label="Descripción"
							value={category.descripcion}
							onChange={handleChange("descripcion")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
							required
						/>
						<Autocomplete
							id="autocomplete-categoria-padre"
							options={categories.filter(
								(item) =>
									item.id !== categoryId && !item.categoria_padre_id
							)}
							getOptionLabel={(option) => option?.descripcion || ""}
							value={
								categories.find((item) => item.id === category.categoria_padre_id) || null
							}
							onChange={(event, selected) =>
								setCategory({
									...category,
									categoria_padre_id: selected?.id || null,
								})
							}
							renderInput={(params) => (
								<TextField
									{...params}
									label="Categoría padre"
									margin="normal"
									variant="outlined"
									InputLabelProps={{ shrink: true }}
								/>
							)}
						/>
						<TextField
							id={`referencia`}
							label="Referencia"
							value={category.referencia}
							onChange={handleChange("referencia")}
							InputLabelProps={{
								shrink: true,
							}}
							margin="normal"
							variant="outlined"
						/>
					</CardBody>
				</Card>
				<Button
					onClick={handleBack}
					variant="outlined"
					style={{ marginRight: "20px" }}
				>
					Atrás
				</Button>
				<Button
					onClick={() => saveCategory()}
					variant="outlined"
					color="primary"
					style={{ marginRight: categoryId ? "20px" : "" }}
				>
					Guardar categoría
				</Button>
				{categoryId && (
					<>
						<MuiThemeProvider theme={theme}>
							<Button
								className="py-2"
								onClick={() => setOpenConfirmDialog(true)}
								variant="outlined"
								color="secondary"
							>
								Eliminar categoría
							</Button>
						</MuiThemeProvider>

						<ConfirmDialog
							title={
								"¿Estás seguro de que quieres eliminar esta categoría?"
							}
							open={openConfirmDialog}
							setOpen={setOpenConfirmDialog}
							onConfirm={() => {
								deletePartidaCategory(
									categoryId,
									loggedUser?.accessToken
								)
									.then((res) => {
										if (
											res.status === 204 ||
											res.status === 200
										) {
											alertSuccess({
												title: "¡Eliminada!",
												customMessage:
													"Categoría eliminada con éxito",
											});
											handleBack();
										}
									})
									.catch((error) => {
										alertError({
											error: error,
											customMessage:
												"No se ha podido eliminar la categoría.",
										});
									});
							}}
						/>
					</>
				)}
			</>
		);
}
